import { render, staticRenderFns } from "./by-login.vue?vue&type=template&id=a28707f0"
import script from "./by-login.vue?vue&type=script&lang=js"
export * from "./by-login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/registration/by-login.vue
// module id = 8cRH
// module chunks = 0